<template>
  <div v-if="hasCustomerProperty">
    <h3>{{ title }}</h3>
    <template v-if="showRentalFields && hasCurrentLivingCondition">
      <a-row v-bind:gutter="16">
        <a-col v-bind:span="12">
          <a-form-item label="Huurcontract staat op naam van">
            <a-radio-group v-if="isMainCustomer"
                           v-model="customerProperty.contract_owner"
                           button-style="solid"
                           v-bind:disabled="disabled" v-on:change="handleContractOwnerChanged">
              <a-radio-button value="main_customer">
                {{ customerName }}
              </a-radio-button>
              <a-radio-button v-if="hasPartner" value="partner">
                {{ partnerName }}
              </a-radio-button>
              <a-radio-button v-if="hasPartner" value="both">
                Beide
              </a-radio-button>
              <a-radio-button value="other">
                Anders
              </a-radio-button>
            </a-radio-group>
            <a-radio-group v-else
                           v-model="customerProperty.contract_owner"
                           button-style="solid"
                           v-bind:disabled="disabled" v-on:change="handleContractOwnerChanged">
              <a-radio-button value="main_customer">
                {{ partnerName }}
              </a-radio-button>
              <a-radio-button v-if="hasPartner" value="partner">
                {{ customerName }}
              </a-radio-button>
              <a-radio-button v-if="hasPartner" value="both">
                Beide
              </a-radio-button>
              <a-radio-button value="other">
                Anders
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col v-bind:span="12">
          <a-form-item label="Overige kosten">
            <amount-input
                v-model="currentLivingCondition.other_costs"
                v-on:change="onCurrentLivingConditionChange"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row v-bind:gutter="16">
        <a-col v-bind:span="12">
          <a-form-item label="Kale huur p/m">
            <amount-input
                v-model="currentLivingCondition.basic_rent"
                v-on:change="onCurrentLivingConditionChange"
            />
          </a-form-item>
        </a-col>
        <a-col v-bind:span="12">
          <a-form-item label="Jaarlijkse huurtstijging">
            <percentage-input
                v-model="currentLivingCondition.rental_increase_rate"
                v-on:change="onCurrentLivingConditionChange"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row v-bind:gutter="16">
        <a-col v-bind:span="12">
          <a-form-item label="Servicekosten">
            <amount-input
                v-model="currentLivingCondition.service_costs"
                v-on:change="onCurrentLivingConditionChange"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </template>

    <template v-if="showResidentFields && hasCurrentLivingCondition">
      <a-row v-bind:gutter="16">
        <a-col v-bind:span="12">
          <a-form-item label="Kosten inwonend p/m">
            <amount-input
                v-model="currentLivingCondition.rental_costs"
                v-on:change="onCurrentLivingConditionChange"/>
          </a-form-item>
        </a-col>
        <a-col v-bind:span="12">
          <a-form-item label="Overige kosten">
            <amount-input
                v-model="currentLivingCondition.other_costs"
                v-on:change="onCurrentLivingConditionChange"/>
          </a-form-item>
        </a-col>
      </a-row>
    </template>

    <template v-if="showPropertyFields && hasProperty && hasCurrentLivingCondition">
      <a-row v-bind:gutter="16">
        <a-col v-bind:span="12">
          <a-form-item label="Geschatte marktwaarde">
            <amount-input
                v-model="property.market_value"
                v-on:change="onPropertyChange"/>
          </a-form-item>
        </a-col>
        <a-col v-bind:span="12">
          <a-form-item label="Doel van de woning">
            <a-radio-group v-model="customerProperty.property_purpose"
                           button-style="solid"
                           v-bind:disabled="disabled"
                           v-on:change="onCustomerPropertyChange">
              <a-radio-button v-for="(purposeName, purpose) in propertyPurposes"
                              v-bind:key="purpose"
                              v-bind:value="purpose">
                {{ purposeName }}
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row v-bind:gutter="16">
        <a-col v-bind:span="12">
          <a-form-item label="WOZ-waarde">
            <amount-input
                v-model="property.real_estate_value"
                v-on:change="onPropertyChange"/>
          </a-form-item>
        </a-col>
        <a-col v-bind:span="12">
          <a-form-item v-bind:label="'Deel ' + customerName">
            <percentage-input
                v-model="customerProperty.percentage_owner"
                addon-after="%"
                type="number"
                v-bind:disabled="disabled"
                v-on:change="onCustomerPropertyChange"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row v-bind:gutter="16">
        <a-col v-bind:span="12">
            <a-form-item label="Koopsom">
                <amount-input
                        v-model="property.purchase_price"
                        v-on:change="onPropertyChange"/>
            </a-form-item>
        </a-col>
        <a-col v-bind:span="12">
            <a-form-item label="Soort woning">
                <a-select
                        v-model="property.type"
                        option-filter-prop="children"
                        placeholder="Kies een soort"
                        show-search
                        style="display: block;"
                        v-bind:filter-option="filterOption"
                >
                    <a-select-option v-for="(typeName, type) in types" v-bind:key="type" v-bind:value="type">
                        {{ typeName }}
                    </a-select-option>
                </a-select>
            </a-form-item>
        </a-col>
      </a-row>
      <a-row v-bind:gutter="16">
        <a-col v-bind:span="12">
            <a-form-item label="Is erfpachtcanon">
                <a-radio-group
                        v-model="property.is_leasehold_canon"
                        button-style="solid"
                        v-on:change="onPropertyChange">
                    <a-radio-button v-bind:value="true">
                        Ja
                    </a-radio-button>
                    <a-radio-button v-bind:value="false">
                        Nee
                    </a-radio-button>
                </a-radio-group>
            </a-form-item>
        </a-col>
        <a-col v-bind:span="12">
          <a-form-item label="Erfpachtcanon">
            <amount-input
                v-model="property.market_value"
                v-bind:disabled="!property.is_leasehold_canon"
                v-on:change="onPropertyChange"/>
          </a-form-item>
        </a-col>
      </a-row>
        <a-row v-bind:gutter="16">
            <a-col v-bind:span="12">
            </a-col>
            <a-col v-bind:span="12">
                <a-form-item label="Erfpachtcanon per jaar">
                    <amount-input
                            v-model="property.leasehold_canon"
                            v-bind:disabled="!property.is_leasehold_canon"
                            v-on:change="onPropertyChange"/>
                </a-form-item>
            </a-col>
        </a-row>
      <template v-if="showPropertyPurposeSellFields || showPropertyPurposeSoldFields">
        <a-row v-bind:gutter="16">
          <a-col v-bind:span="12">
            <a-form-item label="Verkoopprijs">
              <amount-input
                  v-model="currentLivingCondition.sale_price"
                  v-on:change="onCurrentLivingConditionChange"/>
            </a-form-item>
          </a-col>
          <a-col v-bind:span="12">
            <a-form-item label="Verkoopkosten">
              <amount-input
                  v-model="currentLivingCondition.sale_costs"
                  v-on:change="onCurrentLivingConditionChange"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-bind:gutter="16">
          <a-col v-bind:span="12">
            <a-form-item label="Opleverdatum">
              <date-picker-component
                  v-model="currentLivingCondition.date_of_delivery"
                  v-bind:block="true"
                  v-bind:disabled="disabled"
                  v-on:change="onCurrentLivingConditionChange"/>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
    </template>

    <a-form-item v-if="showPropertyFields" label="Beschikbare hypotheken">
      <create-mortgage-property-component v-if="hasCustomer && hasMortgages"
                                          v-bind:customer-id="this.customer.id"
                                          v-bind:mortgages="mortgages"
                                          v-bind:property-id="property.id"/>
    </a-form-item>

    <template v-if="!hasOccupancyType">
      <a-alert
          message="Selecteer eerst het soort woonsituatie."
          type="warning"
          show-icon
      />
    </template>
  </div>
</template>

<script>
import customerCurrentLivingConditionApi from "~/api/customer_current_living_condition";
import propertyApi from "~/api/property";
import customerPropertyApi from "~/api/customer_property";
import editCustomerPropertyComponent from "~/modules/customer_property/components/EditComponent";
import editCustomerCurrentLivingConditionComponent from "./EditComponent";
import createMortgagePropertyComponent from "~/modules/mortgage_property/components/CreateComponent";
import editRentalComponent from "./EditRentalComponent";
import editResidentComponent from "./EditResidentComponent";
import editPropertyComponent from "./EditPropertyComponent";
import {Skeleton} from "vue-loading-skeleton";
import {OccupancyTypeEnum, PropertyPurposeEnum} from "../../../enums";

export default {
  name: "CustomerCurrentLivingConditionEditCustomerComponent",
  components: {
    editCustomerPropertyComponent,
    createMortgagePropertyComponent,
    editCustomerCurrentLivingConditionComponent,
    editRentalComponent,
    editResidentComponent,
    editPropertyComponent,
    Skeleton
  },
  props: {
    livingTogether: {
      required: true,
      type: Boolean
    },
    customerProp: {
      required: true,
      type: Object
    },
    isPartner: {
      required: true,
      type: Boolean
    },
    autoSave: {
      required: false,
      type: Boolean,
      default: true
    },
    partnerProp: {
      required: false,
      type: Object,
      default: null
    },
    propertyProp: {
      required: true,
      type: Object
    },
    customerPropertyProp: {
      required: true,
      type: Object
    },
    currentLivingConditionProp: {
      required: true,
      type: Object
    },
    mortgagesProp: {
      required: true,
      type: Array
    },
    mortgagePropertiesProp: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      customer: this.customerProp,
      partner: this.partnerProp,
      property: this.propertyProp,
      customerProperty: this.customerPropertyProp,
      currentLivingCondition: this.currentLivingConditionProp,
      mortgages: this.mortgagesProp,
      mortgageProperties: this.mortgagePropertiesProp,
      propertyInputKey: 1,
      propertyPersistTimeout: null,
      customerPropertyPersistTimeout: null,
      currentLivingConditionPersistTimeout: null,
      partnerCurrentLivingConditionPersistTimeout: null,
      dataLoaded: true,
      loadingJumba: false,
      loadingCustomerProperty: false,
      occupancyTypes: {
        rental: "Huur",
        resident: "Inwonend",
        property: "Eigendom",
      },
      propertyPurposes: {
        "keep_living": "Blijven wonen",
        "sell": "Verkopen",
        "sold": "Verkocht",
      },
      types: {
        single_family_home: "Eengezinswoning",
        single_family_house_with_garage: "Eengezinswoning met garage",
        flat_apartment: "Flat/appartement",
        flat_apartment_with_garage: "Flat/appartement met garage",
        shop_house: "Winkel-woonhuis",
        residential_house_with_commercial_space: "Woonhuis met bedrijfsruimte",
        store: "Winkel",
        business_premises: "Bedrijfspand",
        recreational_home: "Recreatiewoning",
        farm: "Boerderij",
        business_collateral: "Zakelijk onderpand",
        agricultural_building_land: "Agrarische grond/bouwgrond",
        garage: "Garage",
        building_plot: "Bouwkavel",
        houseboat: "Woonschip",
        pleasure_craft: "Pleziervaartuig",
      },
      currentLivingConditionIncludes: [
        "customer_property",
        "customer_property.property",
        "customer_property.customer",
        "customer_property.property.mortgage_properties",
        "customer_property.property.mortgage_properties.mortgage",
        "mortgages.mortgage_properties"
      ]
    };
  },
  computed: {
    hasProperty() {
      return this.property !== null;
    },
    hasCustomer() {
      return this.customer !== null;
    },
    hasPartner() {
      return this.partner !== null;
    },
    hasMortgages() {
      return typeof this.mortgages !== "undefined" && this.mortgages !== null && this.mortgages.length > 0;
    },
    propertyId() {
      if (this.hasProperty) {
        return this.property.id;
      }
      return null;
    },
    hasCurrentLivingCondition() {
      return this.currentLivingCondition !== null;
    },
    hasPartnerCurrentLivingCondition() {
      return this.partnerCurrentLivingCondition !== null;
    },
    hasCustomerProperty() {
      return this.customerProperty !== null;
    },
    propertyPurpose() {
      if (this.hasCustomerProperty) {
        return this.customerProperty.property_purpose;
      }

      return null;
    },
    propertyOccupancyType() {
      if (this.hasCurrentLivingCondition) {
        return this.currentLivingCondition.type;
      }
    },
    showRentalFields() {
      if (this.hasCurrentLivingCondition) {
        return this.currentLivingCondition.type === OccupancyTypeEnum.RENTAL;
      }
      return false;
    },
    showResidentFields() {
      if (this.hasCurrentLivingCondition) {
        return this.currentLivingCondition.type === OccupancyTypeEnum.RESIDENT;
      }
      return false;
    },
    showPropertyFields() {
      if (this.hasCurrentLivingCondition) {
        return this.currentLivingCondition.type === OccupancyTypeEnum.PROPERTY;
      }
      return false;
    },
    hasOccupancyType() {
      return Object.values(OccupancyTypeEnum)
          .includes(this.currentLivingCondition.type);
    },
    occupancyTypeDescription() {
      switch (this.currentLivingCondition.type) {
        case OccupancyTypeEnum.RENTAL:
          return "Huurwoning";
        case OccupancyTypeEnum.RESIDENT:
          return "Inwonend";
        case OccupancyTypeEnum.PROPERTY:
          return "Koopwoning";
      }

      return "Woonsituatie";
    },
    title() {
      return `${this.occupancyTypeDescription} van ${this.customerLabelName}`;
    },
    customerLabelName() {
      if (this.livingTogether && this.hasPartner) {
        return `${this.customerFirstName} en ${this.partnerFirstName}`;
      }

      return this.customerFirstName;
    },
    showPropertyPurposeKeepLivingFields() {
      return this.propertyPurpose === PropertyPurposeEnum.KEEP_LIVING;
    },
    showPropertyPurposeSellFields() {
      return this.propertyPurpose === PropertyPurposeEnum.SELL;
    },
    showPropertyPurposeSoldFields() {
      return this.propertyPurpose === PropertyPurposeEnum.SOLD;
    },
    isMainCustomer() {
      if (this.customer !== null && typeof this.customer !== "undefined") {
        return this.customer.is_main_customer;
      }
    },
    partnerName() {
      if (this.hasPartner) {
        return this.partner.full_name || "Partner";
      }
      return "Partner";
    },
    partnerFirstName() {
      if (this.hasPartner) {
        return this.partner.first_name || "partner";
      }
      return "partner";
    },
    customerName() {
      if (this.hasCustomer) {
        return this.customer.full_name || "Klant";
      }
      return "Klant";
    },
    customerFirstName() {
      if (this.hasCustomer) {
        return this.customer.first_name || "hoofdklant";
      }
      return "hoofdklant";
    },
    disabled() {
      return this.loadingJumba || this.loadingCustomerProperty;
    }
  },
  mounted() {
    // this.initCustomer();
    // this.initCurrentLivingCondition();
  },
  methods: {
    onSave(currentLivingCondition) {
      if (currentLivingCondition.is_current === false) {
        this.property = null;
        this.customerProperty = null;
      }
    },
    handlePropertyDeleted() {
      let customerProperty = this.customerProperty;
      this.property = null;
      this.customerProperty = null;

      customerProperty.is_current = false;

      customerPropertyApi.update(customerProperty)
          .catch(error => {
          });

      this.$nextTick(() => {
        this.$refs.propertyInputComponent.handleShowPropertyCreate();
      });
    },
    updatePropertyWithJumba() {
      if (this.property !== null) {
        this.loadingJumba = true;

        propertyApi.updateWithJumba(this.property)
            .then(response => {
              this.propertyInputKey++;
              this.property = response.data;
            })
            .finally(() => {
              this.loadingJumba = false;
            });
      }
    },
    handleContractOwnerChanged() {
      if (this.autoSave) {
        this.saveCustomerProperty();
      }
    },
    handleLivingTogetherChange() {

      if (this.autoSave) {
        this.saveCustomerProperty();
      }
    },
    onOccupancyTypeChange() {
      if (this.currentLivingCondition.type === OccupancyTypeEnum.PROPERTY) {
        this.customerProperty.owns_property = true;

        this.customerProperty.percentage_owner = this.customerProperty.percentage_owner || ((this.hasPartner && this.livingTogether) ? 50 : 100);

        this.onCustomerPropertyChange();
      }
      this.onCurrentLivingConditionChange();
    },
    onPropertyChange() {
      this.saveProperty();
    },
    onCustomerPropertyChange() {
      this.saveCustomerProperty();
    },
    onCurrentLivingConditionChange() {
      this.saveCurrentLivingCondition();
    },
    onPartnerCurrentLivingConditionChange() {
      this.savePartnerCurrentLivingCondition();
    },
    saveCurrentLivingCondition() {
      clearTimeout(this.currentLivingConditionPersistTimeout);
      this.currentLivingConditionPersistTimeout = setTimeout(() => {
        customerCurrentLivingConditionApi.update(this.currentLivingCondition)
            .catch();
      }, 500);
    },
    savePartnerCurrentLivingCondition() {
      clearTimeout(this.partnerCurrentLivingConditionPersistTimeout);
      this.partnerCurrentLivingConditionPersistTimeout = setTimeout(() => {
        customerCurrentLivingConditionApi.update(this.partnerCurrentLivingCondition)
            .catch();
      }, 500);
    },
    saveCustomerProperty() {
      clearTimeout(this.customerPropertyPersistTimeout);
      this.customerPropertyPersistTimeout = setTimeout(() => {
        customerPropertyApi.update(this.customerProperty)
            .catch();
      }, 500);
    },
    saveProperty() {
      clearTimeout(this.propertyPersistTimeout);
      this.propertyPersistTimeout = setTimeout(() => {
        propertyApi.update(this.property)
            .catch();
      }, 500);
    },
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase()
              .indexOf(input.toLowerCase()) >= 0
      );
    }
  }
};
</script>
<style scoped>
</style>
